import _objectSpread from '@babel/runtime/helpers/objectSpread2';
const isAvailable = (validationAttribute, state) => {
  if (!validationAttribute) {
    return true;
  }
  const stateKeys = Object.keys(validationAttribute);
  for (let i = 0; i < stateKeys.length; i += 1) {
    const current = stateKeys[i];
    if (validationAttribute[current].indexOf(state[current]) !== -1) {
      return false;
    }
  }
  return true;
};
const isVisible = (validationAttribute, state) => {
  if (!validationAttribute) {
    return true;
  }
  const stateKeys = Object.keys(validationAttribute);
  for (let i = 0; i < stateKeys.length; i += 1) {
    const current = stateKeys[i];
    if (validationAttribute[current].indexOf(state[current]) !== -1) {
      return true;
    }
  }
  return false;
};
const displayOptions = _ref => {
  let {
    options = [],
    state
  } = _ref;
  return options.map(option => {
    const {
      displayAt
    } = option;
    if (!isVisible(displayAt, state)) {
      return null;
    }
    return option;
  }).filter(x => x);
};
const hideOptions = _ref2 => {
  let {
    options = [],
    state
  } = _ref2;
  return options.map(option => {
    const {
      hiddenAt
    } = option;
    if (!isAvailable(hiddenAt, state)) {
      return null;
    }
    return option;
  }).filter(x => x);
};

/* we use &! to tag a state value as serialized and dont rely on try-catch
   Replace all double quotes for escaped double quotes to prevent the andes dropdown from
   breaking when an object is serialized. Eventually, we should get rid of this serialization and handle
   location trees the way is done in the map custom faceted search. See search-nordic
  repo for reference.
*/
const encodeTree = tree => "&!".concat(JSON.stringify(tree).replace(/"/g, '\\"'));
const serializeTree = options => {
  var _options$, _options$2;
  if ((_options$ = options[0]) !== null && _options$ !== void 0 && _options$.level || (_options$2 = options[0]) !== null && _options$2 !== void 0 && _options$2.tree) {
    return options.map(option => {
      let tree = {};
      if (option.level) tree[option.level] = option.id;
      if (option.tree) tree = _objectSpread(_objectSpread({}, tree), option.tree);
      return _objectSpread(_objectSpread({}, option), {}, {
        id: encodeTree(tree)
      });
    });
  }
  return options;
};
const deserializeState = state => Object.keys(state).reduce((acc, key) => {
  const value = state[key];

  // we use &! to tag a state value as serialized and dont rely on try-catch
  if (typeof value === "string" && value.startsWith("&!")) {
    const jsonTree = value.split("&!")[1];
    return _objectSpread(_objectSpread({}, acc), JSON.parse(jsonTree.replace(/\\"/g, '"')));
  }
  return _objectSpread(_objectSpread({}, acc), {}, {
    [key]: value
  });
}, {});
const isIncludedInOptions = (options, value) => {
  for (let i = 0; i < options.length; i += 1) {
    const {
      id
    } = options[i];
    if (id === value || id.indexOf(value) !== -1) {
      return true;
    }
  }
  return false;
};
const reduceOptions = (id, options, state) => {
  if (!options) return [];
  const flatten = serializeTree(options);
  const afterHide = hideOptions({
    options: flatten,
    state
  });
  const afterDisplay = displayOptions({
    options: afterHide,
    state
  });
  return afterDisplay;
};
const enableSwitch = (id, state, setState, enabledAt) => {
  if (!enabledAt) return false;
  if (typeof enabledAt !== "object") return enabledAt;
  const pivotKeys = Object.keys(enabledAt);
  const shouldEnable = pivotKeys.map(stateKey => {
    // dependency must always be an object
    if (typeof enabledAt[stateKey] !== "object") {
      return false;
    }

    // direct level 1 dependency
    if (enabledAt[stateKey][state[stateKey]] === true) {
      return true;
    }

    // if not direct, it can be object or missing
    if (typeof enabledAt[stateKey][state[stateKey]] === "object") {
      const level2Condition = enabledAt[stateKey][state[stateKey]];
      const level2Keys = Object.keys(level2Condition);
      return level2Keys.map(level2Key => {
        if (typeof level2Condition[level2Key] !== "object") {
          return false;
        }

        // direct level 2 dependency
        if (level2Condition[level2Key][state[level2Key]]) {
          return true;
        }
        return false;
      }).reduce((prev, current) => prev || current, false);
    }
    return false;
  }).reduce((prev, current) => prev || current, false);

  // reset switch when disabled
  if (!shouldEnable && state[id]) {
    setState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
      [id]: false
    }));
  }
  return shouldEnable;
};
const disableSearchbox = function () {
  let dependencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let state = arguments.length > 1 ? arguments[1] : undefined;
  if (dependencies.length === 0) {
    return false;
  }
  for (let i = 0; i < dependencies.length; i += 1) {
    const pivotState = state[dependencies[i]];
    if (pivotState === null || pivotState === undefined) {
      return true;
    }
  }
  return false;
};
const searchboxQueryParams = function () {
  let dependencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let state = arguments.length > 1 ? arguments[1] : undefined;
  if (dependencies.length === 0) {
    return "";
  }
  const params = new URLSearchParams();
  for (let i = 0; i < dependencies.length; i += 1) {
    const pivotState = state[dependencies[i]];
    if (pivotState) {
      params.append(dependencies[i], pivotState);
    }
  }
  return params.toString();
};
const getValue = state => (values, dependencyId) => {
  const value = state[dependencyId];
  return _objectSpread(_objectSpread({}, values), {}, {
    [dependencyId]: value
  });
};
const getDependenciesValues = (state, dependencies) => (dependencies === null || dependencies === void 0 ? void 0 : dependencies.reduce(getValue(state), {})) || null;
const DROPDOWN = "selector";
const SWITCH = "switch";
const SEARCHBOX = "searchbox";
const DEFAULT_VALUE_GETTERS_BY_FIELD = {
  [DROPDOWN]: _ref => {
    let {
      options: [defaultOption = null] = []
    } = _ref;
    return defaultOption && defaultOption.id;
  },
  [SWITCH]: () => false,
  [SEARCHBOX]: () => null
};
const getInitialValue = (fieldId, initialValues) => initialValues === null || initialValues === void 0 ? void 0 : initialValues[fieldId];
const getSearchboxValue = (fieldId, initialValues) => {
  const value = initialValues === null || initialValues === void 0 ? void 0 : initialValues[fieldId];
  return value ? encodeTree(value) : null;
};
const VALUE_GETTERS_BY_FIELD = {
  [DROPDOWN]: getInitialValue,
  [SWITCH]: getInitialValue,
  [SEARCHBOX]: getSearchboxValue
};
const buildInitialState = (renderConfig, initialValues) => {
  const getInitialFieldValue = (fields, currentField) => {
    const {
      id,
      type
    } = currentField;
    const getDefaultValue = DEFAULT_VALUE_GETTERS_BY_FIELD[type];
    const getValue = VALUE_GETTERS_BY_FIELD[type];
    if (!getValue) {
      return fields;
    }
    const fieldValue = getValue(id, initialValues) || getDefaultValue(currentField, initialValues);
    return _objectSpread(_objectSpread({}, fields), {}, {
      [id]: fieldValue
    });
  };
  return renderConfig.reduce(getInitialFieldValue, {});
};
const areEqualObjects = (current, previous) => {
  if (current === previous) {
    return true;
  }
  const currentKeys = Object.keys(current);
  for (let i = 0; i < currentKeys.length; i += 1) {
    const dependencyId = currentKeys[i];
    if (current[dependencyId] !== previous[dependencyId]) {
      return false;
    }
  }
  return true;
};
const noop = () => undefined;
const labelMatches = searchTerm => _ref => {
  let {
    label
  } = _ref;
  return label.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
};
const addQueryParams = function (api) {
  let queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  const [basePath, existingParams = ''] = api.split('?');
  const params = [existingParams, queryParams].filter(p => !!p);
  return "".concat(basePath, "?").concat(params.join('&'));
};
const areValidDependencies = function () {
  let deps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const ids = Object.keys(deps);
  for (let i = 0; i < ids.length; i += 1) {
    const id = ids[i];
    if (deps[id] === null || deps[id] === undefined) {
      return false;
    }
  }
  return true;
};
const isValidSearch = function (searchTerm) {
  let minLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  const cleanSearch = searchTerm.trim();
  const meetsMinLength = cleanSearch.length >= minLength;
  return meetsMinLength;
};
export { DROPDOWN as D, SEARCHBOX as S, areEqualObjects as a, buildInitialState as b, disableSearchbox as c, deserializeState as d, SWITCH as e, enableSwitch as f, getDependenciesValues as g, addQueryParams as h, areValidDependencies as i, isValidSearch as j, isIncludedInOptions as k, labelMatches as l, isAvailable as m, noop as n, isVisible as o, encodeTree as p, displayOptions as q, reduceOptions as r, searchboxQueryParams as s, hideOptions as t, serializeTree as u };
